import { MouseEvent, FC } from 'react'
import {
    Button,
    Flex,
    Heading,
    HStack,
    Spacer,
    Wrap,
    WrapItem
} from '@chakra-ui/react'
import { FaRedo } from 'react-icons/fa'
import { SearchTextarea, SearchTitle } from './styled'
import { webGateway as backend } from '../../API'
import { copyToClipboard } from "../utils";
import { Header } from '../Header/Header'

interface IFIXMessageParseInputArea {
    parseError: boolean
    textareaValue: string
    selectedSeqNum?: number
    setTextareaValue: (text: string) => void
    handleShowSample: (event: MouseEvent<HTMLElement>) => void
    handleSend: () => void
}

export const FIXMessageParseInputArea: FC<IFIXMessageParseInputArea> = ({
    textareaValue,
    parseError,
    setTextareaValue,
    handleShowSample,
    selectedSeqNum,
    handleSend
}) => {

    const handleShareBtnClick = () => {
        backend
            .post(
                '/sn/fixparser',
                new URLSearchParams({
                    'raw-fix': textareaValue,
                    'highlighted-row': (selectedSeqNum && selectedSeqNum.toString()) || '0',
                    save: 'true'
                })
            )
            .then((res: any) => {
                const URL = `https://fixparser.chronicle.software?token=${res.data}`
                copyToClipboard(URL)
            })
            .catch(() => {})
    }

    return (
        <Flex
            minHeight='50vh'
            flexDirection='column'
        >
            <Header />
            <Flex
                style={{
                    marginTop: 'auto',
                    marginBottom: 'auto'
                }}
            >
            <Flex
                maxWidth='var(--fix-parser-base-width)'
                width='100%'
                justifyContent='center'
                flexDirection='column'
                margin='auto'
                padding={4}
            >
            <SearchTitle>
                <HStack>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                            fontWeight: '400',
                            margin: '0'
                        }}
                    >
                        FIX Parser
                    </span>
                    <Spacer/>
                </HStack>
            </SearchTitle>
            <SearchTextarea
                placeholder="Paste your own FIX messages here, or press “Random Sample”.  "
                value={textareaValue}
                onChange={(e) => setTextareaValue(e.target.value)}
            />
            <Wrap marginY={6} spacing='16px' justify='end'>
                {parseError && (
                    <WrapItem>
                        <Heading size={'sm'} color="chronicle.orange" pr={3} my={3}>
                            Message parse error!
                        </Heading>
                    </WrapItem>
                )}
                <WrapItem>
                    <Button borderRadius={2} onClick={() => handleSend()}>
                        Parse
                    </Button>
                </WrapItem>
                <WrapItem>
                    <Button borderRadius={2} disabled={!textareaValue} onClick={handleShareBtnClick}>
                        Copy as URL
                    </Button>
                </WrapItem>
                <WrapItem>
                    <Button borderRadius={2} borderWidth={2} onClick={handleShowSample} variant='outline'>
                        <FaRedo style={{ marginRight: '10px' }} />
                        Random Sample
                    </Button>
                </WrapItem>
            </Wrap>
            </Flex>
            </Flex>
        </Flex>
    )
}
